package navigation.home.address

import cafe.adriel.voyager.core.model.StateScreenModel
import cafe.adriel.voyager.core.model.screenModelScope
import com.essntl.core.utils.utils.loadingmanager.LoadingManager
import com.essntl.features.address.domain.repository.AddressRepository
import com.essntl.features.address.ui.AddressEvent
import com.essntl.features.address.ui.AddressState
import com.essntl.features.address.ui.AddressValidation
import com.essntl.features.address.ui.AddressViewModel

class AddressScreenModel(
    addressRepository: AddressRepository,
    loadingManager: LoadingManager,
) : StateScreenModel<AddressState>(AddressState()) {

    val validation = AddressValidation()

    val vm =
        AddressViewModel(
            addressRepository = addressRepository,
            loadingManager = loadingManager,
            state = mutableState,
            scope = screenModelScope,
        )

    fun onEvent(event: AddressEvent) = vm.onEvent(event)
}